const dataHomePage = {
  title: 'Poartă zâmbete - Dăruiește flori!',
  description: 'Ce știm să facem? Oferim oamenilor flori, culori, dragoste și bucurie.',

  featuredTitle: 'A sosit toamna cu darurile ei minunate. Crizanteme la Preț Unic!',
  featuredDescription: ['Începând la doar 15 LEI firul de crizantemă!','*Ofertă valabilă în limita stocului disponibil.'],
  cta: 'Comandă prin telefon',
};

export default dataHomePage;
